import React from 'react';
import { Hero } from '../components/landing/Hero';
import { OpeningHook } from '../components/landing/OpeningHook';
import { ProblemSection } from '../components/landing/ProblemSection';
import { FailedApproaches } from '../components/landing/FailedApproaches';
import { MechanismReveal } from '../components/landing/MechanismReveal';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { AudienceSection } from '../components/landing/AudienceSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { ProofSection } from '../components/landing/ProofSection';
import { FAQSection } from '../components/landing/FAQSection';
import { BonusIntro } from '../components/landing/BonusIntro';
import { BonusStack } from '../components/landing/BonusStack';
import { ValueTable } from '../components/landing/ValueTable';
import { FinalCTA } from '../components/landing/FinalCTA';
import { PostCTAReassurance } from '../components/landing/PostCTAReassurance';
import { Footer } from '../components/landing/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function CortisolSwitchPage() {
  const {
    trackEvent
  } = useMetaPixel();
  return <main className="min-h-screen bg-slate-900 text-slate-50 selection:bg-amber-500/30 selection:text-amber-200" data-id="element-630">
      <Hero data-id="element-631" />
      <OpeningHook data-id="element-632" />
      <ProblemSection data-id="element-633" />
      <FailedApproaches data-id="element-634" />
      <MechanismReveal data-id="element-635" />
      <WhatYouGet data-id="element-636" />
      <AudienceSection data-id="element-637" />
      <HowItWorks data-id="element-638" />
      <ProofSection data-id="element-639" />
      <FAQSection data-id="element-640" />
      <BonusIntro data-id="element-641" />
      <BonusStack data-id="element-642" />
      <ValueTable data-id="element-643" />
      <FinalCTA onAddToCart={() => trackEvent('AddToCart', {
      content_name: 'The Cortisol Switch',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    })} data-id="element-644" />
      <PostCTAReassurance data-id="element-645" />
      <Footer data-id="element-646" />
    </main>;
}